import doc                        from '@widesk-core/decorators/doc';
import model                      from '@widesk-core/decorators/model';
import FileServiceModel           from '@/models/FileServiceModel';
import TimestampAble              from '@widesk-core/models/traits/TimestampAble';
import StonecodeFileTypeModel     from '@models/file/StonecodeFileTypeModel';
import StonecodeFileMimeTypeModel from '@models/file/StonecodeFileMimeTypeModel';

@model.cacheDuration()
@model.urnResource('stonecode_file_type_mime_type')
@doc.path('/stonecode_file_type_mime_types/{?id}')
export default class StonecodeFileTypeMimeTypeModel extends TimestampAble(FileServiceModel) {
	private declare _tsFilters: {
		'mimeType': id;
		'type': id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.string declare type: StonecodeFileTypeModel;
	@doc.string declare mimeType: StonecodeFileMimeTypeModel;
}